<template>
	<div class="main__container">
	    <div class="main__content">
	        <div style="border-bottom: 1px solid #dae2e4; margin-bottom: 20px;">
	            <h1 class="page-title">Browse Aafiyat Search Terms</h1>
	            <ul class="alphabet" style="max-width:600px;">
	                <li v-for="(alpha, index) in data.alphabets" :class="checkActiveLetter(alpha.letter)"><a class="pager__link" :href="alpha.url">{{ alpha.letter.toUpperCase() }}</a></li>
	            </ul>
	            <h1 class="page-title">{{ selectedLetter.toUpperCase() }}</h1>
	        </div>
	        <section>

	        </section>
	    </div>
	    <div class="main__sidebar-first" id="reference">
	        <nav class="directory directory--sidebar" style="padding-right: 20px;">
	            <ul class="menu menu--directory">
	                <li class="menu__item is-active"><a href="#">Browse Terms (A-Z)</a></li>
	            </ul>
	        </nav>
	    </div>
	</div>
</template>

<script>
	export default {
        props: ['data'],
        data() {
        	return {
				selectedLetter: this.data.alpha,				
        	};
        },
        mounted() {
        	console.log(this.selectedLetter);
        },    
        methods: {
        	checkActiveLetter(res) {
        		if (this.selectedLetter == res) {
        			return 'pager__item is-active';
        		}
        		else {
        			return 'pager__item';
        		}
        	},
        },       
	}
</script>